export const CROSS_ICON_SIZE = 18;
